<template>
  <v-app>
    <v-navigation-drawer v-if="isAuthenticated" v-model="drawer" :temporary="display.mobile.value">
      <v-list nav>
        <v-list-item 
          prepend-icon="mdi-view-dashboard" 
          :title="$t('nav.dashboard')" 
          value="dashboard"
          :active="route.path === '/'"
          @click="$router.push('/')"
        ></v-list-item>
        <v-divider v-if="isAdmin" class="my-2"></v-divider>
        <v-list-subheader v-if="isAdmin">{{ $t('nav.main') }}</v-list-subheader>
        <v-list-item
            prepend-icon="mdi-swap-horizontal"
            :title="$t('nav.transactions')"
            value="transactions"
            :active="route.path === '/transactions'"
            @click="$router.push('/transactions')"
        ></v-list-item>
        <v-list-item
            prepend-icon="mdi-chart-line"
            :title="$t('nav.rates')"
            value="rates"
            :active="route.path === '/rates'"
            @click="$router.push('/rates')"
        ></v-list-item>
        <v-list-item
            prepend-icon="mdi-cash-minus"
            :title="$t('nav.expenses')"
            value="expenses"
            :active="route.path === '/expenses'"
            @click="$router.push('/expenses')"
        ></v-list-item>
        <v-list-item
            prepend-icon="mdi-cash-multiple"
            :title="$t('nav.settlements')"
            value="settlements"
            :active="route.path === '/settlements'"
            @click="$router.push('/settlements')"
        ></v-list-item>
        <v-list-item
            prepend-icon="mdi-truck-delivery"
            :title="$t('nav.courierTransfers')"
            value="courier-transfers"
            :active="route.path === '/courier-transfers'"
            @click="$router.push('/courier-transfers')"
        ></v-list-item>
        <v-list-item
            prepend-icon="mdi-file-chart"
            :title="$t('nav.financialReports')"
            value="financial-reports"
            :active="route.path === '/financial-reports'"
            @click="$router.push('/financial-reports')"
        ></v-list-item>
        <v-list-item
            prepend-icon="mdi-table-account"
            :title="$t('nav.budgetReport')"
            value="budget-report"
            :active="route.path === '/budget-report'"
            @click="$router.push('/budget-report')"
        ></v-list-item>
        <v-list-item
            prepend-icon="mdi-table-account"
            :title="$t('nav.pnlReport')"
            value="pnl-report"
            :active="route.path === '/pnl-report'"
            @click="$router.push('/pnl-report')"
        ></v-list-item>
        <v-list-item
            prepend-icon="mdi-format-list-bulleted"
            :title="$t('nav.walletOperations')"
            value="wallet-operations"
            :active="route.path === '/wallet-operations'"
            @click="$router.push('/wallet-operations')"
        ></v-list-item>
        <v-divider v-if="isAdmin" class="my-2"></v-divider>
        <v-list-subheader v-if="isAdmin">{{ $t('nav.catalogs') }}</v-list-subheader>
        <v-list-item 
          prepend-icon="mdi-wallet" 
          :title="$t('nav.wallets')" 
          value="wallets"
          :active="route.path === '/wallets'"
          @click="$router.push('/wallets')"
        ></v-list-item>


        <v-list-item 
          prepend-icon="mdi-currency-btc" 
          :title="$t('nav.coins')" 
          value="coins"
          :active="route.path === '/coins'"
          @click="$router.push('/coins')"
        ></v-list-item>
        <v-list-item 
          prepend-icon="mdi-swap-horizontal-bold" 
          :title="$t('nav.exchanges')" 
          value="exchanges"
          :active="route.path === '/exchanges'"
          @click="$router.push('/exchanges')"
        ></v-list-item>

        <v-list-item 
          prepend-icon="mdi-tag-multiple" 
          :title="$t('nav.expenseTypes')" 
          value="expense-types"
          :active="route.path === '/expense-types'"
          @click="$router.push('/expense-types')"
        ></v-list-item>
        <v-list-item 
          prepend-icon="mdi-account-group" 
          :title="$t('nav.investors')" 
          value="investors"
          :active="route.path === '/investors'"
          @click="$router.push('/investors')"
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-account-multiple"
          :title="$t('nav.clients')"
          value="clients"
          :active="route.path === '/clients'"
          @click="$router.push('/clients')"
        ></v-list-item>
        <v-list-item 
          prepend-icon="mdi-file-tree" 
          :title="$t('nav.budgetLines')" 
          value="budget-lines"
          :active="route.path === '/budget-lines'"
          @click="$router.push('/budget-lines')"
        ></v-list-item>
        <v-divider v-if="isAdmin" class="my-2"></v-divider>
        <v-list-subheader v-if="isAdmin">{{ $t('nav.administration') }}</v-list-subheader>
        <v-list-item 
          v-if="isAdmin"
          prepend-icon="mdi-account-group" 
          :title="$t('nav.users')" 
          value="users"
          :active="route.path === '/users'"
          @click="$router.push('/users')"
        ></v-list-item>
        <v-list-item 
          v-if="isAdmin"
          prepend-icon="mdi-shield-account" 
          :title="$t('nav.roles')" 
          value="roles"
          :active="route.path === '/roles'"
          @click="$router.push('/roles')"
        ></v-list-item>
        <v-list-item 
          v-if="isAdmin"
          prepend-icon="mdi-shield-key" 
          :title="$t('nav.permissions')" 
          value="permissions"
          :active="route.path === '/permissions'"
          @click="$router.push('/permissions')"
        ></v-list-item>
        <v-list-item 
          v-if="isAdmin"
          prepend-icon="mdi-history" 
          :title="$t('nav.versioningConfigs')" 
          value="versioning-configs"
          :active="route.path === '/versioning-configs'"
          @click="$router.push('/versioning-configs')"
        ></v-list-item>
        <v-list-item 
          v-if="isAdmin"
          prepend-icon="mdi-clock-fast" 
          :title="$t('nav.versions')" 
          value="versions"
          :active="route.path === '/versions'"
          @click="$router.push('/versions')"
        ></v-list-item>
        <v-list-item
            prepend-icon="mdi-cog"
            :title="$t('nav.settings')"
            value="settings"
            :active="route.path === '/settings'"
            @click="$router.push('/settings')"
        ></v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block @click="logout" color="error">
            <v-icon start>mdi-logout</v-icon>
            {{ $t('nav.logout') }}
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar v-if="isAuthenticated" color="primary" prominent>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-app-bar-title @click="$router.push('/')" style="cursor: pointer;">{{ $t('app.title') }}</v-app-bar-title>
      <div class="d-flex align-center">
        <v-btn
          v-for="icon in enabledNavbarIconsList"
          :key="icon?.key ?? icon?.route ?? 'icon'"
          v-show="icon && !display.mobile.value && (!icon.adminOnly || isAdmin)"
          icon
          variant="text"
          :title="icon?.title"
          @click="icon && $router.push(icon.route)"
        >
          <v-icon>{{ icon?.icon }}</v-icon>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-btn icon variant="text" @click="toggleTheme" :title="themeTitle">
        <v-icon>{{ themeIcon }}</v-icon>
      </v-btn>
      <v-btn @click="logout" variant="text">{{ $t('nav.logout') }}</v-btn>
    </v-app-bar>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useTheme, useDisplay } from 'vuetify'
import { useI18n } from 'vue-i18n'
import { apiGet, apiPut } from './utils/api'

const { t, locale } = useI18n()

const router = useRouter()
const route = useRoute()
const vTheme = useTheme()
const display = useDisplay()

// Use a ref to track authentication state reactively
const authToken = ref<string | null>(localStorage.getItem('auth_token'))
const currentUserRoles = ref<string[]>([])
const enabledNavbarIconKeys = ref<string[]>([])

// Define all available navbar icons (same as in Settings.vue)
const availableNavbarIcons = computed(() => [
  { key: 'dashboard', icon: 'mdi-view-dashboard', route: '/', title: t('nav.dashboard') },
  { key: 'wallets', icon: 'mdi-wallet', route: '/wallets', title: t('nav.wallets') },
  { key: 'transactions', icon: 'mdi-swap-horizontal', route: '/transactions', title: t('nav.transactions') },
  { key: 'rates', icon: 'mdi-chart-line', route: '/rates', title: t('nav.rates') },
  { key: 'coins', icon: 'mdi-currency-btc', route: '/coins', title: t('nav.coins') },
  { key: 'exchanges', icon: 'mdi-swap-horizontal-bold', route: '/exchanges', title: t('nav.exchanges') },
  { key: 'expenses', icon: 'mdi-cash-minus', route: '/expenses', title: t('nav.expenses') },
  { key: 'expenseTypes', icon: 'mdi-tag-multiple', route: '/expense-types', title: t('nav.expenseTypes') },
  { key: 'investors', icon: 'mdi-account-group', route: '/investors', title: t('nav.investors') },
  { key: 'settlements', icon: 'mdi-cash-multiple', route: '/settlements', title: t('nav.settlements') },
  { key: 'courierTransfers', icon: 'mdi-truck-delivery', route: '/courier-transfers', title: t('nav.courierTransfers') },
  { key: 'financialReports', icon: 'mdi-file-chart', route: '/financial-reports', title: t('nav.financialReports') },
  { key: 'budgetReport', icon: 'mdi-table-account', route: '/budget-report', title: t('nav.budgetReport') },
  { key: 'pnlReport', icon: 'mdi-table-account', route: '/pnl-report', title: t('nav.pnlReport') },
  { key: 'walletOperations', icon: 'mdi-format-list-bulleted', route: '/wallet-operations', title: t('nav.walletOperations') },
  { key: 'budgetLines', icon: 'mdi-file-tree', route: '/budget-lines', title: t('nav.budgetLines') },
  { key: 'settings', icon: 'mdi-cog', route: '/settings', title: t('nav.settings') },
  { key: 'users', icon: 'mdi-account-group', route: '/users', title: t('nav.users'), adminOnly: true },
  { key: 'roles', icon: 'mdi-shield-account', route: '/roles', title: t('nav.roles'), adminOnly: true },
  { key: 'permissions', icon: 'mdi-shield-key', route: '/permissions', title: t('nav.permissions'), adminOnly: true },
  { key: 'versioningConfigs', icon: 'mdi-history', route: '/versioning-configs', title: t('nav.versioningConfigs'), adminOnly: true },
  { key: 'versions', icon: 'mdi-clock-fast', route: '/versions', title: t('nav.versions'), adminOnly: true },
])

// Computed list of enabled navbar icons
const enabledNavbarIconsList = computed(() => {
  if (enabledNavbarIconKeys.value.length === 0) {
    // If no icons set, return all available icons (default behavior)
    return availableNavbarIcons.value.filter(icon => icon && (!icon.adminOnly || isAdmin.value))
  }
  // Return only enabled icons from user settings
  return availableNavbarIcons.value.filter(icon => 
    icon && enabledNavbarIconKeys.value.includes(icon.key) && (!icon.adminOnly || isAdmin.value)
  )
})

// Update auth token when localStorage changes
const updateAuthToken = () => {
  authToken.value = localStorage.getItem('auth_token')
}

// Listen to storage events to sync across tabs
window.addEventListener('storage', (e) => {
  if (e.key === 'auth_token') {
    updateAuthToken()
  }
})

// Listen to custom auth event for same-tab updates
window.addEventListener('auth-changed', () => {
  updateAuthToken()
})

// Load user roles when authenticated
const loadCurrentUser = async () => {
  if (!authToken.value) {
    currentUserRoles.value = []
    enabledNavbarIconKeys.value = []
    return
  }
  
  try {
    const response = await apiGet('/api/users/current')
    if (response.ok) {
      const userData = await response.json()
      currentUserRoles.value = userData.roles?.map((r: any) => r.name) || []
      
      // Load and apply language from user settings
      if (userData.language) {
        locale.value = userData.language as 'en' | 'ru'
        localStorage.setItem('locale', userData.language)
      }
      
      // Load and apply theme from user settings
      if (userData.theme) {
        vTheme.change(userData.theme as any)
        localStorage.setItem('theme', userData.theme)
      }
      
      // Load navbar icons from user settings
      if (userData.navbar_icons && Array.isArray(userData.navbar_icons) && userData.navbar_icons.length > 0) {
        // If it's an array of objects with key, extract keys
        if (userData.navbar_icons[0] && typeof userData.navbar_icons[0] === 'object' && 'key' in userData.navbar_icons[0]) {
          enabledNavbarIconKeys.value = userData.navbar_icons.map((icon: any) => icon.key)
        } else if (typeof userData.navbar_icons[0] === 'string') {
          // If it's an array of strings (keys)
          enabledNavbarIconKeys.value = userData.navbar_icons
        } else {
          // Default to empty array (will show all icons via computed)
          enabledNavbarIconKeys.value = []
        }
      } else {
        // Default to empty array (will show all icons via computed)
        enabledNavbarIconKeys.value = []
      }
    }
  } catch (error) {
    console.error('Load current user error:', error)
    currentUserRoles.value = []
    enabledNavbarIconKeys.value = []
  }
}

// Listen for navbar icons changes from Settings page
window.addEventListener('navbar-icons-changed', () => {
  if (authToken.value) {
    loadCurrentUser()
  }
})

// Listen for locale changes from Settings page
window.addEventListener('locale-changed', ((e: CustomEvent) => {
  if (e.detail?.locale) {
    locale.value = e.detail.locale as 'en' | 'ru'
    localStorage.setItem('locale', e.detail.locale)
  }
}) as EventListener)

// Also check on route changes in case login happens in same tab
router.afterEach(() => {
  updateAuthToken()
  if (authToken.value) {
    loadCurrentUser()
  }
})

// Load user roles when authenticated
watch(authToken, (token) => {
  if (token) {
    loadCurrentUser()
  } else {
    currentUserRoles.value = []
  }
}, { immediate: true })

onMounted(() => {
  if (authToken.value) {
    loadCurrentUser()
  }
})

const isAuthenticated = computed(() => {
  return authToken.value !== null
})

const isAdmin = computed(() => {
  return currentUserRoles.value.includes('admin')
})

// Initialize drawer as closed by default
const drawer = ref(false)

// Watch authentication state and close drawer when logged out
watch(isAuthenticated, (authenticated) => {
  if (!authenticated) {
    drawer.value = false
  }
}, { immediate: true })

const logout = () => {
  localStorage.removeItem('auth_token')
  authToken.value = null
  drawer.value = false
  router.push('/login')
}

const themeIcon = computed(() => (vTheme.global.current.value.dark ? 'mdi-weather-sunny' : 'mdi-weather-night'))
const themeTitle = computed(() => (vTheme.global.current.value.dark ? t('settings.switchToLight') : t('settings.switchToDark')))
const toggleTheme = async () => {
  const next = vTheme.global.current.value.dark ? 'light' : 'dark'
  vTheme.change(next as any)
  localStorage.setItem('theme', next)
  
  // Save to user settings if authenticated
  if (authToken.value) {
    try {
      await apiPut('/api/users/current', {
        user: { theme: next }
      })
    } catch (error) {
      console.error('Error saving theme:', error)
    }
  }
}

// Close drawer when route changes (on mobile only) or when going to login
router.afterEach((to) => {
  if (display.mobile.value || to.path === '/login') {
    drawer.value = false
  }
})

// Drawer stays closed by default - user can open it manually via the hamburger menu
</script>

